export default __webpack_public_path__ + "static/media/bmm-extinguisher.0d32c6bc.jpeg";